// // src/api/axiosInstance.js
// import axios from 'axios';
// import { baseUrl } from '../config/default';

// const axiosInstance = axios.create({
//     baseURL: baseUrl, // example base URL
//     headers: {
//         'Content-Type': 'application/json',
//     },
// });

// // Add request interceptor
// axiosInstance.interceptors.request.use(
//     config => {
//         const token = localStorage.getItem('suat');
//         if (token) {
//             config.headers.Authorization = `Bearer ${token}`;
//         }
//         return config;
//     },
//     error => Promise.reject(error)
// );

// // Add response interceptor
// axiosInstance.interceptors.response.use(
//     response => {
//         return response;
//     },
//     error => {
//         console.error('[Error]', error.response);
//         return Promise.reject(error);
//     }
// );

// export default axiosInstance;

// src/api/axiosInstance.js
// import axios from 'axios';
// import { baseUrl } from '../config/default';

// const axiosInstance = axios.create({
//   baseURL: baseUrl,
//   withCredentials: true, // ⭐ REQUIRED FOR COOKIE AUTH
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Request interceptor (NO TOKEN HANDLING)
// axiosInstance.interceptors.request.use(
//   config => config,
//   error => Promise.reject(error)
// );

// // Response interceptor (OPTIONAL LOGGING)
// axiosInstance.interceptors.response.use(
//   response => response,
//   error => {
//     console.error('[API Error]', error.response);
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;

// src/api/axiosInstance.js
import axios from "axios";
import { baseUrl } from "../config/default";

const axiosInstance = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach(promise =>
    error ? promise.reject(error) : promise.resolve()
  );
  failedQueue = [];
};

// Request interceptor
axiosInstance.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
  response => response,

  async error => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      // Queue parallel requests
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => axiosInstance(originalRequest));
      }

      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem("rtust");

        // ❌ No refresh token → force logout
        // if (!refreshToken) {
        //   throw new Error("Refresh token missing");
        // }

        // 🔁 Call your EXISTING re-auth API
        await axios.post(
          `${baseUrl}/users/generate-access-token`,
          {},           // 👈 token from localStorage
          { withCredentials: true }
        );

        processQueue(null);
        return axiosInstance(originalRequest);

      } catch (refreshError) {
        processQueue(refreshError);

        // ❌ Refresh expired / invalid
        localStorage.clear();
        sessionStorage.clear();
        // window.location.href = "/login";
        // window.location.reload();

        return Promise.reject(refreshError);

      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
